import { Checkbox } from 'antd';

const CheckboxRenderer = (params) => {
  return <Checkbox checked={params.value}></Checkbox>;
};

export default CheckboxRenderer;
